import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../LanguageContext';
const getSteps = (t: any) => [{
  num: '01',
  title: t('step_1_title'),
  description: t('step_1_desc')
}, {
  num: '02',
  title: t('step_2_title'),
  description: t('step_2_desc')
}, {
  num: '03',
  title: t('step_3_title'),
  description: t('step_3_desc')
}, {
  num: '04',
  title: t('step_4_title'),
  description: t('step_4_desc')
}];
export function Process() {
  const {
    t
  } = useLanguage();
  const steps = getSteps(t);
  return <section className="py-24 bg-white" data-id="element-273">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-274">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-275">
          <motion.h2 className="text-4xl font-extrabold text-navy mb-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-276">
            {t('process_title')}
          </motion.h2>
          <motion.p className="text-lg text-slate-600" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} data-id="element-277">
            {t('process_desc')}
          </motion.p>
        </div>

        <div className="relative" data-id="element-278">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-slate-200 -translate-y-1/2 z-0" data-id="element-279" />
          <motion.div className="hidden md:block absolute top-1/2 left-0 h-0.5 bg-electric -translate-y-1/2 z-0 origin-left" initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1.5,
          ease: 'easeInOut'
        }} data-id="element-280" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-6 relative z-10" data-id="element-281">
            {steps.map((step, index) => <motion.div key={index} className="flex flex-col items-center text-center relative" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2 + 0.5
          }} data-id="element-282">
                {/* Connecting Line (Mobile) */}
                {index !== steps.length - 1 && <div className="md:hidden absolute top-16 left-1/2 w-0.5 h-full bg-slate-200 -translate-x-1/2 -z-10" data-id="element-283" />}

                <div className="w-16 h-16 rounded-full bg-white border-4 border-electric flex items-center justify-center text-xl font-bold text-navy mb-6 shadow-lg shadow-electric/20 relative z-10" data-id="element-284">
                  {step.num}
                </div>
                <h3 className="text-xl font-bold text-navy mb-3" data-id="element-285">
                  {step.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed px-2" data-id="element-286">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}